import { map } from "lodash";
import { LoadingDots } from "PFComponents/loading_dots";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { usePermissionsGroup } from "PFCore/hooks/queries/admin/use_permissions_group";
import { usePermissionsGroups } from "PFCore/hooks/queries/admin/use_permissions_groups";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import PermissionsGroupEditPage from "PFModules/admin/permissions_groups/edit/permissions_group_edit_page";
import React from "react";
import { useParams } from "react-router";

const sanitizeForCreate = (permissionsGroup) => ({
  ...permissionsGroup,
  id: null,
  default: false,
  display_as: "",
  name: "",
  custom_types_access_levels: { own_profile: {}, activities: {} },
  cross_group_permissions: {},
  permissions: map(permissionsGroup.permissions, ({ name }) => ({
    name,
    permitted: false
  }))
});

export const PermissionsGroupEditController = () => {
  const { id } = useParams<{ id: string }>();

  const { data: permissionsGroups, isError: isPermissionsGroupsError } = usePermissionsGroups(1, 1000);
  const { data: permissionsGroup, isError: isPermissionsGroupError } = usePermissionsGroup(id, {
    enabled: !!id
  });
  const { data: currentProfile } = useCurrentProfile();

  if (isPermissionsGroupError || isPermissionsGroupsError) {
    return <NotFoundComponent />;
  }

  if ((id && !permissionsGroup) || !permissionsGroups) {
    return <LoadingDots circlesEnabled pageViewEnabled />;
  }

  const sanitizedPermissionsGroup = id ? permissionsGroup : sanitizeForCreate(permissionsGroups.entries[0]);

  return (
    <PermissionsGroupEditPage
      permissionsGroup={sanitizedPermissionsGroup}
      permissionsGroups={permissionsGroups.entries}
      customTypes={currentProfile.custom_types}
    />
  );
};
